import { useState, useEffect } from 'react'

// local imports
import LocationService from 'service/LocationService'
import { IAllLocationList } from 'types/LocationType'
import { PlanTabs } from 'types/PlanTabs'

export default function useGetAllLocations(resType: (PlanTabs | undefined)[]) {
  const [locationList, setLocationList] = useState<IAllLocationList[] | undefined>()
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(false)

  function fetchData() {
    setIsLoading(true)
    LocationService.GetAllLocationList()
      .then((r) => {
        const sharedOffices = r.data?.filter((dt) => !dt.isMyFirmLocation)
        const firmOffices = r.data?.filter((dt) => !!dt.isMyFirmLocation)

        if (resType.length === 0 || resType.length === 2) {
          setLocationList(r.data)
        } else if (resType.includes(PlanTabs.COMMON)) {
          setLocationList(sharedOffices)
        } else if (resType.includes(PlanTabs.OFFICE)) {
          setLocationList(firmOffices)
        }
      })
      .catch((err) => setError(true))
      .finally(() => setIsLoading(false))
  }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => fetchData(), [resType])

  return { locationList, isLoading, error }
}
